module.exports = "<span style=\"font-size: 0.8em;\">{{ countdown }} {{countDownSuffix}}</span>"